module.exports = __webpack_public_path__ + "img/floatExplain.0f0d9894.svg";